import React, { useEffect, useState } from 'react'
import Loader from '../Utils/Loader'
import { fetchParams } from '../../services/paramsApi'
import '../../css/params.css'

export default function ParamsListExt({ refreshKey }) {
  const [loading, setLoading] = useState(true)
  const [params, setParams]   = useState({ dinamici: {}, statici: {} })

  useEffect(() => {
    setLoading(true)
    fetchParams()
      .then(res => {
        // alcuni wrapper restituiscono i dati in res.data
        const payload = res.data || res
        setParams({
          dinamici: payload.dinamici || {},
          statici:  payload.statici  || {},
        })
      })
      .finally(() => setLoading(false))
  }, [refreshKey])

  if (loading) {
    return (
      <div className="loader-wrapper">
        <Loader />
      </div>
    )
  }

  return (
    <div className="params-list">
      <div className="params-section">
        <h2>Parametri Dinamici</h2>
        <div className="pre-container">
          <pre>{JSON.stringify(params.dinamici, null, 2)}</pre>
        </div>
      </div>
      <div className="params-section">
        <h2>Parametri Statici</h2>
        <div className="pre-container">
          <pre>{JSON.stringify(params.statici, null, 2)}</pre>
        </div>
      </div>
    </div>
  )
}
